<template>

  <!-- First section for editing the line -->
  <tr v-if='editLine'>
    <td>
      <v-autocomplete
        ref='description'
        dense
        single-line
        hide-details
        :items='product'
        item-text='description'
        v-model='selected'
        return-object
        @change='update'
        class='body-2'
      >
      </v-autocomplete>
    </td>
    <td>
      <v-form v-model='isFormValid'>
        <v-text-field
          ref='quantity'
          :id="'quantity' + line.id"
          dense
          single-line
          reverse
          hide-details
          class='body-2'
          @focus='selectQuantity'
          :rules='[rules.int]'
          v-model.number='lineCopy.qty'
        ></v-text-field>
      </v-form>
    </td>
    <td class='text-right'>
      {{ getSubtotal }}
    </td>
    <td>
      <v-checkbox class='ml-2 mt-0 mb-n4' dense v-model='lineCopy.is_warranty'></v-checkbox>
    </td>
    <td class='text-right'>
      {{ getTotal }}
    </td>
    <td valign='middle' align='middle'>
      <v-btn
        x-small
        :disabled='savingLine'
        color='error'
        dark
        class='mr-1'
        @click='cancel'
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
      <template v-if='isFormValid && selected.description'>
        <v-btn
          x-small
          :loading='savingLine'
          color='success'
          @click='saveLine'
        >
        <template v-slot:loader>
          <v-progress-circular color='white' indeterminate :size='14' :width='1'></v-progress-circular>
        </template>
          <v-icon small>mdi-check</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-tooltip top>
          <template v-slot:activator='{ on }'>
            <v-btn
              v-on='on'
              x-small
              color='error'
            >
              <v-icon small>mdi-alert-circle</v-icon>
            </v-btn>
          </template>
          <span>Error in description, qty or price</span>
        </v-tooltip>
      </template>
    </td>
  </tr>

  <!-- This section just for displaying the line -->
  <tr v-else>
    <td :class='fontColor + "--text"'>
      {{ line.product_obj.description }}
    </td>
    <td class='text-right' :class='fontColor + "--text"'>
      {{ line.qty }}
    </td>
    <td class='text-right' :class='fontColor + "--text"'>
      {{ line.product_obj.service_price | dec }}
    </td>
    <td class='text-right' :class='fontColor + "--text"'>
      {{ line.is_warranty | trueFalse }}
    </td>
    <td class='text-right' :class='fontColor + "--text"'>
      {{ (line.is_warranty ? 0 : line.product_obj.service_price) * line.qty | dec }}
    </td>
    <td class='text-right'>
      <wc-line-actions
        v-if='!disableEdit'
        hideSortUp
        hideSortDown
        @edit='setupEdit'
        @deleteLine="$emit('deleteLine', line)"
      >
      </wc-line-actions>
    </td>
  </tr>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'work-order-processing-product-line',
  mixins: [formRules],
  props: {
    line: {
      required: true
    },
    editMode: {
      required: false,
      type: Boolean,
      default: false
    },
    product: {
      required: true,
      type: Array,
    },
    fontColor: {
      required: false,
      type: String,
      default: 'grey'
    },
    disableEdit: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    editLine: false,
    lineCopy: {},
    savingLine: false,
    isFormValid: false,
    inputClass: 'body-2',
    selected: {
      description: ''
    }
  }),
  computed: {
    getTotal() {
      return this.$options.filters.dec(this.lineCopy.qty * (this.lineCopy.is_warranty ? 0 : this.lineCopy.product_obj.service_price))
    },
    getSubtotal () {
      return this.$options.filters.dec(this.lineCopy.product_obj.service_price)
    }
  },
  mounted () {
    if (this.editMode) {
      this.setupEdit()
    }
  },
  methods: {
    setupEdit () {
      this.lineCopy = _.cloneDeep(this.line)
      if (this.lineCopy.product !== '') {
        this.selected = _.find(this.product, i => i.id === this.lineCopy.product )
      } else {
        this.selected = this.product[0]
        this.lineCopy.product_obj.service_price = this.selected.service_price
      }
      this.editLine = true
    },
    saveLine () {
      this.savingLine = true
      this.lineCopy.product = this.selected.id
      this.$emit('save', this.lineCopy)
      this.editLine = false
      this.savingLine = false
    },
    update () {
      // called if the user changed the product.
      this.lineCopy.product_obj.service_price = this.selected.service_price
      this.isFormValid = true
      this.selectQuantity()
    },
    selectQuantity() {
      setTimeout(() => {
        document.getElementById('quantity'+this.line.id).select()
      }, 50)
    },
    cancel () {
      if (this.editMode) {
        this.$emit('cancelCreate')
      }
      this.editLine = false
    }
  }
}
</script>